

class HeaderController {
  constructor() {
  	'ngInject';

  	this.header = "Rangers";  	
  }  
}

HeaderController.$inject = []

export default HeaderController;



// WEBPACK FOOTER //
// ./client/app/layout/header.controller.js